import { deserializeURLSearchParams, validateParams } from "@/lib/utils";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useDebouncedCallback } from "use-debounce";
import z from "zod";

export function useQueryHandler(debounceMs = 300) {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  const schema = z.object({
    q: z.string().optional(),
  });
  const { q: query } = validateParams(
    schema,
    deserializeURLSearchParams(searchParams.toString()),
  );

  const handleSearch = useDebouncedCallback((term: string) => {
    const params = new URLSearchParams(searchParams);

    if (term) {
      params.set("q", term);
    } else {
      params.delete("q");
    }

    // Reset to page 1 only if 'p' already exists in the URL
    if (params.has("p")) {
      params.set("p", "1");
    }

    router.replace(`${pathname}?${params.toString()}`, { scroll: false });
  }, debounceMs);

  return {
    query,
    handleSearch,
  };
}
